import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {};
  },
  methods: {
    beforeGetList() {
      // const date = new Date();
      // const year = date.getFullYear();
      // const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const day = date.getDate().toString().padStart(2, '0');
      // const currentDate = `${year}-${month}-${day}`;
      // if (
      //   !this.searchFormData.createTimeStart
      //   && !this.searchFormData.createTimeEnd
      // ) {
      //   this.searchFormData = {
      //     ...this.searchFormData,
      //     createTimeStart: `${currentDate} 00:00:00`,
      //     createTimeEnd: `${currentDate} 23:59:59`,
      //   };
      //   this.formData = {
      //     ...this.formData,
      //     createTimeStart: `${currentDate} 00:00:00`,
      //     createTimeEnd: `${currentDate} 23:59:59`,
      //   };
      // }
      return true;
    },
    afterGetList() {
      this.exportParams = this.paramsProps;
      return true;
    },
  },
  created() {
    this.getConfigList('detail_list');
  },
};
